const env = window.STUDENT_ENV ? window.STUDENT_ENV : window.APP_ENV;
const ENV = env == null ? void 0 : env.env;
const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const LMS_BASE_URL = "lms_base_url";
const ENROLLMENT_SESSION_TOKEN = "enrollment_session_token";
const CONTENT_TOOLKIT_GATEWAY_URL = env == null ? void 0 : env.CONTENT_TOOLKIT_GATEWAY_URL;
const CONTENT_TOOLKIT_FLAGS_URL = env == null ? void 0 : env.CONTENT_TOOLKIT_FLAGS_URL;
const CONTENT_TOOLKIT_EVENTS_ENABLED = (env == null ? void 0 : env.CONTENT_TOOLKIT_EVENTS_ENABLED) === "true";
const AUTH_API_URL = env == null ? void 0 : env.AUTH_API_URL;
const STUDENT_API_URL = env == null ? void 0 : env.STUDENT_API_URL;
const STUDENT_FEATURE_FLAG_API_URL = env == null ? void 0 : env.FEATURE_FLAG_API_URL;
const ENROLLMENT_API_URL = env == null ? void 0 : env.ENROLLMENT_API_URL;
const USER_API_URL = env == null ? void 0 : env.USER_API_URL;
const COURSE_API_URL = env == null ? void 0 : env.COURSE_API_URL;
const COURSE_CTK_API_URL = env == null ? void 0 : env.COURSE_CTK_API_URL;
const ENOTE_API_URL = env == null ? void 0 : env.ENOTE_API_URL;
const SECTION_API_URL = env == null ? void 0 : env.SECTION_API_URL;
const GRADING_API_URL = env == null ? void 0 : env.GRADING_API_URL;
const ORGANIZATION_API_URL = env == null ? void 0 : env.ORGANIZATION_API_URL;
const AETHER_API_URL = env == null ? void 0 : env.AETHER_API_URL;
const STUDENT_SESSION_TIMEOUT = Number(env == null ? void 0 : env.STUDENT_SESSION_TIMEOUT);
const REFERENCE_SHEETS_BASE_URL = env == null ? void 0 : env.REFERENCE_SHEETS_BASE_URL;
const STUDENT_EDGENUITY_APP_URL = env == null ? void 0 : env.STUDENT_EDGENUITY_APP_URL;
const STUDENT_LOGIN_URL = env == null ? void 0 : env.STUDENT_LOGIN_URL;
const STUDENT_LOGOUT_URL = "/logout";
const STUDENT_PROFILE_URL = env == null ? void 0 : env.STUDENT_PROFILE_URL;
const HELP_CENTER_URL = env == null ? void 0 : env.HELP_CENTER_URL;
const ITEM_ENGINE_AUTHOR_URI = env == null ? void 0 : env.ITEM_ENGINE_AUTHOR_URI;
const ITEM_ENGINE_ITEMS_URI = env == null ? void 0 : env.ITEM_ENGINE_ITEMS_URI;
const ENROLLMENT_SESSION_REFRESH_FREQUENCY_MILLIS = env == null ? void 0 : env.ENROLLMENT_SESSION_REFRESH_FREQUENCY_MILLIS;
const ATTEMPT_SESSION_TIMED_ASSESSMENT_REFRESH_FREQUENCY_MILLIS = env == null ? void 0 : env.ATTEMPT_SESSION_TIMED_ASSESSMENT_REFRESH_FREQUENCY_MILLIS;
const RUBRIC_ENGINE_RUBRICS_URI = env == null ? void 0 : env.RUBRIC_ENGINE_RUBRICS_URI;
const ZENDESK_URL = env == null ? void 0 : env.ZENDESK_URL;
const GET_PROCTORIO_URL = env == null ? void 0 : env.GET_PROCTORIO_URL;
export {
  ACCESS_TOKEN_KEY,
  AETHER_API_URL,
  ATTEMPT_SESSION_TIMED_ASSESSMENT_REFRESH_FREQUENCY_MILLIS,
  AUTH_API_URL,
  CONTENT_TOOLKIT_EVENTS_ENABLED,
  CONTENT_TOOLKIT_FLAGS_URL,
  CONTENT_TOOLKIT_GATEWAY_URL,
  COURSE_API_URL,
  COURSE_CTK_API_URL,
  ENOTE_API_URL,
  ENROLLMENT_API_URL,
  ENROLLMENT_SESSION_REFRESH_FREQUENCY_MILLIS,
  ENROLLMENT_SESSION_TOKEN,
  ENV,
  GET_PROCTORIO_URL,
  GRADING_API_URL,
  HELP_CENTER_URL,
  ITEM_ENGINE_AUTHOR_URI,
  ITEM_ENGINE_ITEMS_URI,
  LMS_BASE_URL,
  ORGANIZATION_API_URL,
  REFERENCE_SHEETS_BASE_URL,
  REFRESH_TOKEN_KEY,
  RUBRIC_ENGINE_RUBRICS_URI,
  SECTION_API_URL,
  STUDENT_API_URL,
  STUDENT_EDGENUITY_APP_URL,
  STUDENT_FEATURE_FLAG_API_URL,
  STUDENT_LOGIN_URL,
  STUDENT_LOGOUT_URL,
  STUDENT_PROFILE_URL,
  STUDENT_SESSION_TIMEOUT,
  USER_API_URL,
  ZENDESK_URL
};
